import { Tag, TagLabel, Box, Tooltip, TagProps } from '@chakra-ui/react';
import { ITag, TagType } from 'types';
import { useTranslation } from "react-i18next";

export const UKTag = ({ tag, tagProps }: { tag: ITag; tagProps?: TagProps }) => {
    const { t } = useTranslation('common');
  const tagType = tag.type;
  return (
    <Tooltip
      hasArrow
      placement="bottom"
      label={tag.type === TagType.OVER_12_MONTHS_UK ? <Over12Months /> : <Less12Months />}
    >
      <Tag
        size="xs"
        variant="solid"
        data-selector={`tag-uk-resident-${
          tagType === TagType.OVER_12_MONTHS_UK ? 'over-12-months' : 'under-12-months'
        }`}
        {...tagProps}
      >
        <Box
          bgColor="white"
          color="gray.500"
          borderRadius="sm"
          fontSize="3xs"
          fontWeight="bold"
          letterSpacing="tight"
          lineHeight="3"
          mr="0.5"
          px="1px"
          py="1px"
        >
          {t('common:uk')}
                          </Box>

        <TagLabel>{tag.label}</TagLabel>
      </Tag>
    </Tooltip>
  );
};

const Over12Months = () => {
    const { t } = useTranslation('common');
  return (
    <>
      {t('common:applyingFromTheUk')}
                <br /> {t('common:inCountryOver12Months')}
              </>
  );
};

const Less12Months = () => {
    const { t } = useTranslation('common');
  return (
    <>
      {t('common:applyingFromTheUk')}
                <br /> {t('common:inCountryLessThan12Months')}
              </>
  );
};
